/* eslint-disable max-lines */
import { useEffect, useState } from 'react'
import { useI18n, formatPrice } from '@popety_io/popety-io-lib'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import { useSelector } from 'react-redux'

import { estimateSelector } from '../../../redux'

const EstimatedPrice = () => {
  const estimate = useSelector(estimateSelector)

  const [data, setData] = useState({
    price: 0,
    lowRange: 0,
    upperRange: 0,
    reliability: '',
  })

  const { t } = useI18n()

  useEffect(() => {
    setData({
      price: estimate?.price
        ? estimate?.price
        : Math.round(
            ((estimate?.valueRange?.lower || 0) +
              (estimate?.valueRange?.upper || 0)) /
              2,
          ),
      lowRange: estimate?.lowRange || estimate?.valueRange?.lower,
      upperRange: estimate?.upperRange || estimate?.valueRange?.upper,
      reliability: estimate?.confidence
        ? estimate.confidence.charAt(0).toUpperCase() +
          estimate.confidence.slice(1)
        : '',
    })
  }, [estimate])

  return (
    <Box
      sx={{
        marginTop: '20px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
        }}
      >
        <Typography
          variant="h6"
          sx={{
            marginBottom: '4px',
            fontSize: '1.1rem',
            textTransform: 'uppercase',
            color: (theme) => theme.palette.secondary.main,
          }}
        >
          {t('estimate.summary.Estimation du prix')}
        </Typography>
      </Box>

      <Grid container display="flex" justifyContent="flex-start">
        <Grid item xs={12} sm={6} md={4}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              paddingBottom: '5px',
              paddingTop: '5px',
            }}
          >
            <Typography
              color="primary"
              variant="h4"
              fontWeight="bold"
              fontSize="1.5rem"
            >
              {formatPrice(data.price)}
            </Typography>
            <Typography
              variant="h5"
              sx={{
                color: '#969696',
                paddingBottom: '10px',
              }}
              fontSize="1rem"
            >
              {data?.price &&
                estimate.area &&
                formatPrice(Math.round(data.price / estimate.area))}
              / m2
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              paddingBottom: '5px',
              paddingTop: '5px',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                gap: '10px',
                paddingBottom: '5px',
                color: (theme) => theme.palette.secondary.main,
              }}
            >
              <Typography fontWeight={500} fontSize="1rem">
                {t('estimate.summary.Fourchette basse')}
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Typography
                  color="primary"
                  fontWeight={600}
                  sx={{
                    fontSize: '1em',
                  }}
                >
                  {formatPrice(data.lowRange)}
                </Typography>
                <Typography
                  sx={{
                    color: '#969696',
                    paddingBottom: '10px',
                  }}
                  fontSize="0.8rem"
                >
                  {data?.lowRange
                    ? formatPrice(
                        Math.round(
                          (data?.lowRange || 1675100) / (estimate?.area || 100),
                        ),
                      )
                    : 'CHF 0'}{' '}
                  /m2
                </Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                gap: '10px',
                paddingBottom: '5px',
                color: (theme) => theme.palette.secondary.main,
              }}
            >
              <Typography fontWeight={500} fontSize="1rem">
                {t('estimate.summary.Fourchette haute')}
              </Typography>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <Typography
                  color="primary"
                  fontWeight={600}
                  sx={{
                    fontSize: '1rem',
                  }}
                >
                  {formatPrice(data.upperRange)}
                </Typography>
                <Typography
                  sx={{
                    color: '#969696',
                    paddingBottom: '10px',
                  }}
                  fontSize="0.8rem"
                >
                  {data?.upperRange
                    ? formatPrice(
                        Math.round(
                          (data?.upperRange || 2150700) /
                            (estimate?.area || 100),
                        ),
                      )
                    : 'CHF 0'}{' '}
                  /m2
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default EstimatedPrice
